import PropTypes from 'prop-types';
import React from 'react';
import Loader from './loader.jsx';
import { httpGET, json } from '../actions/utils';
import env from '../env';

const { REDSHELF_READER_URL } = env;


function fetchLaunchParams(url) {
    return httpGET(url).then(json);
}


export default class EmbedLTI1p3 extends React.Component {
    static displayName = 'EmbedLTI1p3';

    static propTypes = {
        content: PropTypes.any,
    };

    iframe = React.createRef();
    form = React.createRef();
    contentWrapper = React.createRef();


    constructor(props, context) {
        super(props, context);

        this.state = {};
        this.onResize = this.onResize.bind(this);

        this.params_uri =
            "/api/v4/content/"
            + this.props.content.id
            + "/lti1p3_params/";
    }


    onResize() {
        const iframe = this.iframe.current;
        const parent = this.contentWrapper.current;

        if (!(iframe && parent)) return;

        iframe.style.cssText = `
            width: 0;
            height: 0;
        `;

        iframe.style.cssText = `
            width: ${parent.offsetWidth};
            height: ${parent.offsetHeight -
                document.querySelector('.navbar').offsetHeight};
        `;
    }


    renderInputs(params) {
        return Object.keys(params).map(key => {
            return (
                <input
                    key={key}
                    type="hidden"
                    name={key}
                    value={params[key]}
                />
            );
        });
    }


    componentDidUpdate(prevProps, prevState) {
        if (!prevState.params && this.state.params) {
            this.form.current.submit();
        }
        this.onResize();
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }


    componentDidMount() {
        window.addEventListener('resize', this.onResize);

        fetchLaunchParams(this.params_uri)
            .then(params => {
                this.setState({
                    params: params
                });
            });
    }


    render() {
        if(!this.state.params) {
            return <Loader message="Fetching launch data" />;
        }

        const params = this.state.params;
        const id = this.props.content.id;
        const key = 'iframe-' + id;
        const clipboardPermissions = 'clipboard-write ' + REDSHELF_READER_URL;

        return (
            <div>
                <div className="embedded-content-container lti-content">
                    <div
                        className="embedded-content-wrapper"
                        ref={this.contentWrapper}
                    >
                        <iframe
                            name={key}
                            id={key}
                            title="Embedded LTI"
                            ref={this.iframe}
                            allow={clipboardPermissions}
                        />
                        <form
                            ref={this.form}
                            target={key}
                            action={params.login_url}
                            method="POST"
                            encType="application/x-www-form-urlencoded"
                        >
                            {this.renderInputs(params)}
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/embed_lti1p3.jsx